export const SOURCE_SELECT_TEST_ID = 'source-select';
export const SOURCE_WARNING_TEST_ID = 'source-warning';

export const OTHER_JOURNEY_TOOLTIP_CONTENT =
  'This trigger type can’t be changed because other workflows are linked to it. To change this trigger type, first update or remove the “Send to workflow” nodes in those workflows.';
